export default "__VITE_ASSET__C6dx_Sgh__"